(function () {
  'use strict';

  var CDN = 'https://cdn.shopify.com/s/files/1/0780/9751/4709/files/';

  var IMG = {
    logo:          CDN + 'faffle-web-logo.png',
    quokkaFull:    CDN + 'email-bottom-header.webp',
    footerCart:    CDN + 'footer-cart-600.webp',
    headers: {
      overthinker:      CDN + 'overthinker-header.webp',
      analyst:          CDN + 'analyst-header.webp',
      avoider:          CDN + 'avoider-header.webp',
      people_pleaser:   CDN + 'people-pleaser-header.webp',
      chaotic_wildcard: CDN + 'chaotic-wildcard-header.webp'
    }
  };

  var TRAIT_LABEL = {
    overthinker:      'an Overthinker',
    analyst:          'an Analyst',
    avoider:          'an Avoider',
    people_pleaser:   'a People Pleaser',
    chaotic_wildcard: 'a Chaotic Wildcard'
  };

  var TRAIT_DISPLAY = {
    overthinker:      'The Overthinker',
    analyst:          'The Analyst',
    avoider:          'The Avoider',
    people_pleaser:   'The People Pleaser',
    chaotic_wildcard: 'The Chaotic Wildcard'
  };

  /* ── All 25 trait combinations ──────────────────────────────────── */

  var CONTENT = {
    overthinker: {
      preheader: 'You already thought about this before you clicked submit.',
      labelLine: "today you're feeling like…",
      primaryHtml: [
        '<p class="fr-stanza">But you already knew that, didn\'t you?<br>You\'ve probably been thinking about it since question two.</p>',
        '<p>You don\'t move on from things.</p>',
        '<p>You revisit them.</p>',
        '<p>At 2am.</p>',
        '<p>From a slightly different angle.</p>',
        '<p class="fr-stanza">Just to check.</p>',
        '<p class="fr-stanza">That conversation from last Tuesday?<br>Still open in a background tab.</p>',
        '<p class="fr-stanza">That thing you said that no one else remembers?<br>You\'ve drafted three better versions of it since.</p>',
        '<p>You\'re even rethinking the answers to this quiz now aren\'t you?</p>'
      ].join(''),
      secondary: {
        analyst: {
          divider: 'Also…',
          intro: 'kind of Analytical, really.',
          html: [
            '<p class="fr-stanza">You don\'t just overthink — you organise the overthinking.</p>',
            '<p>You\'ve ranked your worries.</p>',
            '<p>Prioritised your spirals.</p>',
            '<p class="fr-stanza">Filed the 2am thoughts under subheadings.</p>',
            '<p>Other people panic.</p>',
            '<p class="fr-stanza">You\'ve already mapped out three scenarios and a contingency.</p>',
            '<p>You are stressed. But at least it\'s structured.</p>'
          ].join('')
        },
        avoider: {
          divider: 'But.',
          intro: 'You also tend to Avoid things…',
          html: [
            '<p>There are things you haven\'t touched.</p>',
            '<p>Small things. Easy things.</p>',
            '<p class="fr-stanza">Things that would take five minutes if you just did them.</p>',
            '<p>Instead, they sit there.</p>',
            '<p class="fr-stanza">And you think about them.</p>',
            '<p>So now you\'ve got things you\'re not doing.</p>',
            '<p class="fr-stanza">And thoughts about the things you\'re not doing.</p>',
            '<p>Efficient.</p>'
          ].join('')
        },
        people_pleaser: {
          divider: 'And yeah…',
          intro: "You're a People Pleaser.",
          html: [
            '<p>You said yes to something four days ago.</p>',
            '<p>You didn\'t want to.</p>',
            '<p class="fr-stanza">You knew you didn\'t want to at the time.</p>',
            '<p class="fr-stanza">You\'ve rehearsed how to get out of it eleven times since.<br>In the shower. In the car. Once at 1am with your eyes closed.</p>',
            '<p>Every version sounded reasonable.</p>',
            '<p class="fr-stanza">You haven\'t used any of them.</p>',
            '<p>You\'re still going.</p>'
          ].join('')
        },
        chaotic_wildcard: {
          divider: 'And yeah…',
          intro: 'you go off the charts sometimes. We call it The Chaotic Wildcard.',
          html: [
            '<p class="fr-stanza">You spiralled about it for days.<br>Went back and forth.</p>',
            '<p class="fr-stanza">Thought about every possible outcome.</p>',
            '<p class="fr-stanza">Then had a wine and said fuck it.<br>Sent the text. Booked the thing. Said the quiet part out loud.</p>',
            '<p>And now?</p>',
            '<p>Now you\'ve got a whole new thing to overthink.</p>'
          ].join('')
        },
        none: {
          divider: 'But.',
          intro: null,
          html: [
            '<p class="fr-stanza">Most people have a secondary trait.<br>A little twist. Something else going on underneath.</p>',
            '<p class="fr-stanza">You don\'t.</p>',
            '<p class="fr-stanza">You just got Overthinker. Again.<br>Every single answer. Every single question.</p>',
            '<p class="fr-stanza">You thought about it. Then thought about it again.<br>Then picked the answer you were already going to pick. Then questioned it.</p>',
            '<p>We tried to find something else in there.</p>',
            '<p class="fr-stanza">There is nothing else in there.</p>',
            '<p>Just thoughts. About thoughts. About other thoughts.</p>',
            '<p>You\'re even overthinking this result right now aren\'t you?</p>'
          ].join('')
        }
      }
    },

    analyst: {
      preheader: "You already had a theory, didn't you?",
      labelLine: "today you're feeling like…",
      primaryHtml: [
        '<p class="fr-stanza">You\'re going to read this, nod, and think "yeah, that tracks."</p>',
        '<p class="fr-stanza">Something goes wrong and everyone around you panics.<br>You don\'t.<br>You just need a second.<br>You\'re not ignoring it, you\'re processing it. There\'s a difference.</p>',
        '<p class="fr-stanza">You\'ve definitely corrected someone who didn\'t ask to be corrected.<br>And you genuinely didn\'t understand why they got annoyed.<br>You were helping.</p>',
        '<p>You\'ve got a right way to do things.</p>',
        '<p>And you will quietly judge anyone who does it wrong.</p>',
        '<p>You\'re not difficult.</p>',
        '<p>You\'re just right a lot.</p>',
        '<p>And that\'s everyone else\'s problem.</p>'
      ].join(''),
      secondary: {
        overthinker: {
          divider: 'But.',
          intro: 'you tend to overthink those decisions.',
          html: [
            '<p>You were right.</p>',
            '<p class="fr-stanza">You\'re always right.</p>',
            '<p>But the way you said it. Did that land okay?</p>',
            '<p class="fr-stanza">Was that too blunt? They went quiet after.</p>',
            '<p>That was four days ago.</p>',
            '<p>You\'ve replayed it nine times.</p>',
            '<p>You were right every single time.</p>',
            '<p>Didn\'t help.</p>'
          ].join('')
        },
        avoider: {
          divider: 'But.',
          intro: 'You also tend to Avoid things…',
          html: [
            '<p>You\'ve assessed the situation.</p>',
            '<p>Identified the problem.</p>',
            '<p class="fr-stanza">Mapped out exactly what needs to happen.<br>In order. With steps. Colour coded headings. Sub headings. And references.</p>',
            '<p>That was three weeks ago.</p>',
            '<p>The plan is perfect.</p>',
            '<p>The plan is untouched.</p>',
            '<p>You started a new plan anyway.</p>'
          ].join('')
        },
        people_pleaser: {
          divider: 'And yeah…',
          intro: "You're a People Pleaser.",
          html: [
            '<p>You wrote the pros and cons list.</p>',
            '<p>Highlighted it.</p>',
            '<p>Colour coded it.</p>',
            '<p class="fr-stanza">Had the answer right there.</p>',
            '<p class="fr-stanza">Then made the decision based on a gut feeling in the car park.</p>',
            '<p>You have the answers.</p>',
            '<p>You just don\'t use them.</p>',
            '<p>Honestly, it\'s impressive.</p>'
          ].join('')
        },
        chaotic_wildcard: {
          divider: 'And yeah…',
          intro: 'you go off the charts sometimes. We call it The Chaotic Wildcard.',
          html: [
            '<p>You know the right way to do this.</p>',
            '<p class="fr-stanza">You\'ve always known the right way to do this.</p>',
            '<p class="fr-stanza">Someone asked you to do it their way instead.<br>And you said yes.</p>',
            '<p>So now you\'re doing it wrong.</p>',
            '<p>On purpose.</p>',
            '<p>With a smile on your face.</p>',
            '<p>And it is killing you.</p>'
          ].join('')
        },
        none: {
          divider: 'But.',
          intro: null,
          html: [
            '<p class="fr-stanza">Most people have a secondary trait.<br>A little twist. Something else going on underneath.</p>',
            '<p class="fr-stanza">You don\'t.</p>',
            '<p class="fr-stanza">You just got Analyst. Again.<br>Every single question.<br>You read it. Assessed it. Selected the most logical answer. Clicked Next.<br>No hesitation. No chaos. No feelings getting in the way.</p>',
            '<p>We looked for a crack somewhere.</p>',
            '<p>A wobble.</p>',
            '<p class="fr-stanza">Anything.</p>',
            '<p>There is nothing.</p>',
            '<p>You are concerningly consistent.</p>',
            '<p>And you probably think that\'s a compliment.</p>'
          ].join('')
        }
      }
    },

    avoider: {
      preheader: "You almost didn't click submit.",
      labelLine: "today you're feeling like…",
      primaryHtml: [
        '<p class="fr-stanza">You\'re not lazy.<br>You\'re just... selectively unavailable.</p>',
        '<p>That thing you need to do?</p>',
        '<p>You\'ve seen it.</p>',
        '<p>Noted it.</p>',
        '<p>Mentally rescheduled it four times.</p>',
        '<p>It would take five minutes.</p>',
        '<p>You walked past it again this morning.</p>',
        '<p>You\'ll walk past it again tomorrow.</p>'
      ].join(''),
      secondary: {
        analyst: {
          divider: 'Also…',
          intro: 'kind of Analytical, really.',
          html: [
            '<p class="fr-stanza">You haven\'t done the thing.<br>But you have researched the thing.</p>',
            '<p>You\'ve compared options. Read reviews.</p>',
            '<p class="fr-stanza">Found the most efficient approach.</p>',
            '<p class="fr-stanza">You could explain exactly how to do it to someone else.<br>In detail. With steps.</p>',
            '<p>You just haven\'t done it yourself.</p>',
            '<p>Fully qualified. Zero experience.</p>'
          ].join('')
        },
        overthinker: {
          divider: 'But.',
          intro: 'geez, at least stop Overthinking it…',
          html: [
            '<p class="fr-stanza">It\'s not just sitting there undone.<br>It\'s sitting there undone while you think about it.</p>',
            '<p class="fr-stanza">Constantly.</p>',
            '<p>You know exactly what you need to do.</p>',
            '<p>How long it will take.</p>',
            '<p class="fr-stanza">What happens if you don\'t.</p>',
            '<p class="fr-stanza">You\'ve spent more time thinking about it than it would\'ve taken just to do it.</p>',
            '<p>You\'re still not going to do it though.</p>',
            '<p>Obviously.</p>'
          ].join('')
        },
        people_pleaser: {
          divider: 'And yeah…',
          intro: "You're a People Pleaser.",
          html: [
            '<p>Someone else\'s thing?</p>',
            '<p>Done.</p>',
            '<p>Immediately.</p>',
            '<p class="fr-stanza">Without being asked.</p>',
            '<p>Your thing?</p>',
            '<p class="fr-stanza">Still sitting there.</p>',
            '<p>You\'ll rearrange your entire day for someone else\'s problem.</p>',
            '<p class="fr-stanza">And step right over your own on the way out the door.</p>',
            '<p>Predictable.</p>'
          ].join('')
        },
        chaotic_wildcard: {
          divider: 'And yeah…',
          intro: 'you go off the charts sometimes. We call it The Chaotic Wildcard.',
          html: [
            '<p>The thing you\'ve been avoiding?</p>',
            '<p>You will eventually do it.</p>',
            '<p>Not now.</p>',
            '<p>Not in the right order.</p>',
            '<p class="fr-stanza">And definitely not the way anyone expected.</p>',
            '<p class="fr-stanza">But one random Tuesday at 11pm you\'ll suddenly do all of it.<br>In one chaotic burst.<br>Badly.<br>And somehow it\'ll be fine.</p>',
            '<p>Somehow.</p>'
          ].join('')
        },
        none: {
          divider: 'But.',
          intro: null,
          html: [
            '<p class="fr-stanza">Most people have a secondary trait.<br>A little twist. Something else going on underneath.</p>',
            '<p class="fr-stanza">You don\'t.</p>',
            '<p class="fr-stanza">You just got Avoider. Again.<br>Every single question.<br>You picked the path of least resistance. Every time.</p>',
            '<p>We tried to find something else in there.</p>',
            '<p>A hidden layer.</p>',
            '<p class="fr-stanza">A secret depth.</p>',
            '<p>There isn\'t one.</p>',
            '<p>You\'re avoiding even having a secondary personality trait.</p>',
            '<p>On brand.</p>'
          ].join('')
        }
      }
    },

    people_pleaser: {
      preheader: 'You answered for someone else at least once.',
      labelLine: 'we picked up cues that',
      primaryHtml: [
        '<p class="fr-stanza">You said yes three times during this quiz without even checking what the question was.</p>',
        '<p class="fr-stanza">It\'s not something you think about.<br>It just happens.</p>',
        '<p>Someone needs something...<br>you\'re already doing it.</p>',
        '<p class="fr-stanza">Someone looks slightly off...<br>you\'ve already adjusted.</p>',
        '<p>You don\'t say no.</p>',
        '<p>Not because you can\'t.</p>',
        '<p class="fr-stanza">You just never get to it.<br>The yes is out before the no even wakes up.</p>',
        '<p>And now you\'ve got four things on your plate that aren\'t yours, a reply you sent too fast, and a favour you forgot you agreed to.</p>',
        '<p>But sure. No worries.</p>',
        '<p>You\'re fine.</p>'
      ].join(''),
      secondary: {
        analyst: {
          divider: 'Also…',
          intro: 'kind of Analytical, really.',
          html: [
            '<p>You watch yourself do it... Every time.</p>',
            '<p class="fr-stanza">Adjust your tone. Soften your opinion. Make them feel comfortable.</p>',
            '<p>You can see the pattern.</p>',
            '<p>You\'ve clocked it.</p>',
            '<p class="fr-stanza">You could map it out on a whiteboard.</p>',
            '<p>Doesn\'t stop you.</p>',
            '<p>Next time it happens, you\'ll watch yourself do it again.</p>',
            '<p>Like someone else took over.</p>'
          ].join('')
        },
        avoider: {
          divider: 'But.',
          intro: 'You also tend to Avoid things…',
          html: [
            '<p>You said yes two weeks ago.</p>',
            '<p class="fr-stanza">Meant it at the time. Genuinely.</p>',
            '<p class="fr-stanza">Haven\'t started.</p>',
            '<p class="fr-stanza">You haven\'t told them you haven\'t started either.<br>You\'ve just been hoping they forgot.</p>',
            '<p>They haven\'t.</p>',
            '<p class="fr-stanza">You know they haven\'t.</p>',
            '<p>You\'re avoiding that conversation too.</p>'
          ].join('')
        },
        overthinker: {
          divider: 'But.',
          intro: 'sometimes you spiral and Overthink…',
          html: [
            '<p>You had an idea for a friend.</p>',
            '<p class="fr-stanza">What. How. When.<br>You had the whole thing worked out.</p>',
            '<p>Then you started second-guessing it.</p>',
            '<p>What if it\'s too much.</p>',
            '<p>What if it\'s not enough.</p>',
            '<p class="fr-stanza">What if they read it wrong.</p>',
            '<p class="fr-stanza">So you just thought about it.<br>And the moment passed.</p>',
            '<p>They\'ll never know you were going to.</p>',
            '<p class="fr-stanza">It only ever existed inside your head.</p>',
            '<p>But you know.</p>',
            '<p>And now it\'s 2am.</p>'
          ].join('')
        },
        chaotic_wildcard: {
          divider: 'And yeah…',
          intro: 'you go off the charts sometimes. We call it The Chaotic Wildcard.',
          html: [
            '<p>You said yes to everything.</p>',
            '<p>All of it.</p>',
            '<p class="fr-stanza">Every single thing anyone asked.</p>',
            '<p class="fr-stanza">And now your week looks like a crime scene.<br>Three things overlap.<br>Two of them are today.<br>One of them you don\'t even remember agreeing to.</p>',
            '<p>You\'ll figure it out.</p>',
            '<p>You always do.</p>',
            '<p>It just won\'t be pretty.</p>'
          ].join('')
        },
        none: {
          divider: 'And yeah…',
          intro: null,
          html: [
            '<p class="fr-stanza">Most people have a secondary trait.<br>A little twist. Something else going on underneath.</p>',
            '<p class="fr-stanza">You don\'t.</p>',
            '<p class="fr-stanza">You just got People Pleaser. Again.<br>Every single question.<br>You picked the answer that would make everyone else comfortable.</p>',
            '<p>We tried to find something underneath.</p>',
            '<p>A boundary.</p>',
            '<p>A limit.</p>',
            '<p class="fr-stanza">A single no.</p>',
            '<p>There isn\'t one.</p>',
            '<p>You people pleased your way through a personality quiz.</p>',
            '<p>That takes a special kind of commitment.</p>'
          ].join('')
        }
      }
    },

    chaotic_wildcard: {
      preheader: 'You almost picked randomly. Almost.',
      labelLine: "today you're feeling like…",
      primaryHtml: [
        '<p>You don\'t do things in order.</p>',
        '<p class="fr-stanza">You just react in the moment.</p>',
        '<p class="fr-stanza">Somewhere right now there\'s a half-finished something you forgot about.</p>',
        '<p>A message you should\'ve re-read before sending.</p>',
        '<p class="fr-stanza">And a problem you\'ve created that you don\'t know about yet.</p>',
        '<p>You don\'t cause chaos on purpose.</p>',
        '<p class="fr-stanza">It just follows you around like a loyal dog you never trained.</p>',
        '<p>And the thing is?</p>',
        '<p>You\'re not stressed about any of it.</p>',
        '<p>Well. Maybe. Kinda.</p>'
      ].join(''),
      secondary: {
        analyst: {
          divider: 'But.',
          intro: 'you do have Analytical tendencies…',
          html: [
            '<p>You bought the planner.</p>',
            '<p>The tabs.</p>',
            '<p>The label maker.</p>',
            '<p class="fr-stanza">Some TikTok reel you watched. Full intention.</p>',
            '<p>They\'re in a cupboard somewhere.</p>',
            '<p class="fr-stanza">Still in the packaging.</p>',
            '<p>You don\'t need a system.</p>',
            '<p>You just like buying one.</p>'
          ].join('')
        },
        avoider: {
          divider: 'But.',
          intro: 'You also tend to Avoid things…',
          html: [
            '<p>Which is an interesting combination.</p>',
            '<p class="fr-stanza">Because you don\'t avoid things quietly.<br>You avoid things loudly.</p>',
            '<p class="fr-stanza">By doing something else entirely.</p>',
            '<p>That important thing you need to deal with?</p>',
            '<p>You started a podcast instead.</p>',
            '<p>Or rearranged your room.</p>',
            '<p class="fr-stanza">Or suddenly decided now is the time to learn sourdough.</p>',
            '<p>The thing is still there.</p>',
            '<p>But you\'ve been very busy not doing it.</p>',
            '<p>Impressively busy.</p>'
          ].join('')
        },
        people_pleaser: {
          divider: 'And yeah…',
          intro: "You're a People Pleaser.",
          html: [
            '<p>You cause chaos everywhere you go.</p>',
            '<p class="fr-stanza">And then feel terrible about it.</p>',
            '<p>Not terrible enough to stop.</p>',
            '<p class="fr-stanza">Just terrible enough to apologise really well afterwards.</p>',
            '<p>You\'ve got a gift for the cleanup.</p>',
            '<p>The "sorry I forgot" text.</p>',
            '<p class="fr-stanza">The "I know I said I would" voice.</p>',
            '<p>People forgive you every time.</p>',
            '<p>That\'s probably not helping.</p>'
          ].join('')
        },
        overthinker: {
          divider: 'But.',
          intro: "if only you didn't Overthink everything afterwards…",
          html: [
            '<p>You did the thing.</p>',
            '<p>Didn\'t think about it.</p>',
            '<p class="fr-stanza">Didn\'t hesitate. Classic you.</p>',
            '<p class="fr-stanza">Then at 3am your brain decided to go back and review everything.<br>Not in order. Not logically.<br>Just random flashes of things you said, did, or possibly imagined.</p>',
            '<p>Great timing.</p>'
          ].join('')
        },
        none: {
          divider: 'And yeah…',
          intro: null,
          html: [
            '<p class="fr-stanza">Most people have a secondary trait.<br>A little twist. Something else going on underneath.</p>',
            '<p class="fr-stanza">You don\'t.</p>',
            '<p class="fr-stanza">You just got Chaotic Wildcard. Again.<br>Every single question.<br>You picked whatever felt right in the moment.<br>No pattern. No logic. Just vibes.</p>',
            '<p>We tried to find a thread.</p>',
            '<p>A theme.</p>',
            '<p class="fr-stanza">Anything that connected your answers together.</p>',
            '<p>There isn\'t one.</p>',
            '<p class="fr-stanza">You are beautifully, chaotically, unmappable.</p>',
            '<p>And honestly? You probably stopped reading this halfway through anyway.</p>'
          ].join('')
        }
      }
    }
  };

  /* ── Helpers ──────────────────────────────────────────────────── */

  function param(name) {
    try { return new URLSearchParams(window.location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  function normalise(raw) {
    return raw.replace(/^the-/, '').replace(/-/g, '_');
  }

  function pick(pool) {
    return pool[Math.floor(Math.random() * pool.length)];
  }

  function pickFrom(traitKey) {
    var pool = (window.FAFFLE_TRAIT_PRODUCTS || {})[traitKey];
    return (pool && pool.length) ? pick(pool) : null;
  }

  function pickSecond(traitKey, exclude) {
    var pool = (window.FAFFLE_TRAIT_PRODUCTS || {})[traitKey];
    if (!pool || !pool.length) return null;
    var others = pool.filter(function (p) { return p.url !== (exclude && exclude.url); });
    return others.length ? pick(others) : pool[0];
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(product, displayName) {
    if (!product) return '';
    return (
      '<a class="fr-product" href="' + esc(product.url) + '">' +
        '<img class="fr-product-img" src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy">' +
        '<p class="fr-product-name">' + esc(product.title) + '</p>' +
        '<p class="fr-product-tag">' + esc(displayName) + '</p>' +
        '<span class="fr-product-cta">Have a look</span>' +
      '</a>'
    );
  }

  /* ── Render ───────────────────────────────────────────────────── */

  function render(primaryKey, secondaryKey, name) {
    var cfg = CONTENT[primaryKey];
    if (!cfg) return;

    var secData = cfg.secondary[secondaryKey] || cfg.secondary['none'];
    var isDoubleDown = (secondaryKey === 'none');

    var nameDisplay = name || 'there';
    var header = IMG.headers[primaryKey] || '';
    var label = TRAIT_LABEL[primaryKey] || '';
    var displayName = TRAIT_DISPLAY[primaryKey] || '';
    var secDisplayName = isDoubleDown ? displayName : (TRAIT_DISPLAY[secondaryKey] || '');

    var primaryProduct = pickFrom(primaryKey);
    var secondaryProduct = isDoubleDown
      ? pickSecond(primaryKey, primaryProduct)
      : pickFrom(secondaryKey);

    /* Reveal line — People Pleaser has a different opener */
    var revealHtml = (primaryKey === 'people_pleaser')
      ? 'Hey ' + esc(nameDisplay) + ', we picked up cues that<br><span class="fr-trait-name">you\'re a People Pleaser</span>'
      : 'Hey ' + esc(nameDisplay) + ', ' + esc(cfg.labelLine) + '<br><span class="fr-trait-name">' + esc(label) + '</span>';

    /* Secondary section */
    var secondarySection = '';
    if (secData) {
      secondarySection =
        '<div class="fr-twist">' +
          '<div class="fr-twist-ornament">' +
            '<div class="fr-twist-line"></div>' +
            '<p class="fr-twist-word">' + esc(secData.divider) + '</p>' +
            '<div class="fr-twist-line"></div>' +
          '</div>' +
        '</div>' +
        (secData.intro
          ? '<div class="fr-secondary-intro"><p>' + esc(secData.intro) + '</p></div>'
          : '') +
        '<div class="fr-body">' + secData.html + '</div>';
    }

    var html =
      '<div class="fr-backdrop" id="fr-backdrop">' +
        '<div class="fr-modal" role="dialog" aria-modal="true" aria-label="Your Faffle result">' +

          '<button class="fr-close" id="fr-close" aria-label="Close">&times;</button>' +

          '<div class="fr-top-bar">' + esc(cfg.preheader) + '</div>' +

          '<div class="fr-logo-panel">' +
            '<img src="' + esc(IMG.logo) + '" alt="Faffle &amp; Co" height="34">' +
          '</div>' +

          '<div class="fr-hero">' +
            '<img src="' + esc(header) + '" alt="' + esc(displayName) + '" loading="eager">' +
          '</div>' +

          '<p class="fr-reveal">' + revealHtml + '</p>' +

          '<div class="fr-body">' + cfg.primaryHtml + '</div>' +

          secondarySection +

          '<div class="fr-divider"><div class="fr-divider-line"></div></div>' +

          '<div class="fr-quokka-wrap">' +
            '<div class="fr-quokka-text">' +
              '<p class="fr-stanza">We see you. And honestly? We kind of love it.</p>' +
              '<p>But enough about you.<br><em>(Just kidding. It\'s all about you.)</em><br>That\'s why we found these tees we think you\'ll like.</p>' +
            '</div>' +
          '</div>' +

          '<div class="fr-products">' +
            card(primaryProduct, displayName) +
            card(secondaryProduct, secDisplayName) +
          '</div>' +

          '<div class="fr-footer-img">' +
            '<img src="' + esc(IMG.footerCart) + '" alt="" loading="lazy">' +
          '</div>' +

          '<div class="fr-signoff">' +
            '<p class="fr-signoff-heading">I hope you had fun with the quiz. :)</p>' +
            '<p class="fr-signoff-message">If you\'re anything like me, you\'ll probably swing between traits depending on the day, the situation, or how much sleep you\'ve had.</p>' +
            '<p class="fr-signoff-message">You\'re always welcome to come back, retake the quiz, and see what version of yourself shows up next time.</p>' +
            '<p class="fr-signoff-closer">Big Aussie Squeezes,</p>' +
            '<p class="fr-signoff-name">Zoe</p>' +
          '</div>' +

          '<div class="fr-welcome-bar">Welcome to the Faffles Club. 🤍</div>' +

          '<div class="fr-brand-footer">' +
            '<p class="fr-brand-mark">Faffle &amp; Co</p>' +
            '<p class="fr-brand-tagline">Embrace the Faff.</p>' +
            '<button class="fr-close-link" id="fr-close-link">Close this popup</button>' +
          '</div>' +

        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', html);
    document.body.style.overflow = 'hidden';

    function close() {
      var bd = document.getElementById('fr-backdrop');
      if (bd) bd.remove();
      document.body.style.overflow = '';
    }

    document.getElementById('fr-close').addEventListener('click', close);
    document.getElementById('fr-close-link').addEventListener('click', close);

    document.getElementById('fr-backdrop').addEventListener('click', function (e) {
      if (e.target === this) close();
    });

    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
    });
  }

  /* ── "Picking your tee…" cover ────────────────────────────────────
     Shown the instant pick mode redirects, so the visitor never sees the
     launchpad product flash before bouncing to their real tee.          */
  function showPicking() {
    if (document.getElementById('fr-picking')) return;
    var st = document.createElement('style');
    st.textContent = '@keyframes fr-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);

    var ov = document.createElement('div');
    ov.id = 'fr-picking';
    ov.setAttribute('style', [
      'position:fixed', 'inset:0', 'z-index:99999',
      'display:flex', 'flex-direction:column',
      'align-items:center', 'justify-content:center',
      'background:#FEFCFA', 'text-align:center'
    ].join(';'));
    ov.innerHTML =
      '<div style="width:38px;height:38px;border:3px solid #E5E1D8;' +
        'border-top-color:#A85F4F;border-radius:50%;' +
        'animation:fr-spin 0.8s linear infinite;margin-bottom:18px;"></div>' +
      '<p style="font-family:Georgia,\'Times New Roman\',serif;font-style:italic;' +
        'font-size:22px;color:#7E9876;margin:0;">Picking your tee…</p>';
    (document.body || document.documentElement).appendChild(ov);
  }

  /* ── Init ─────────────────────────────────────────────────────── */

  function init() {
    if (param('fr') !== '1') return;

    var traitHandle  = param('trait');
    if (!traitHandle) return;

    var primaryKey   = normalise(traitHandle);
    if (!CONTENT[primaryKey]) return;

    var secondaryRaw = param('secondary') || 'none';

    /* ── Router mode ──────────────────────────────────────────────
       ?pick=1 means "I haven't landed on a product yet — send me to a
       random tee for my trait, then show the popup there." Used by the
       recovery email, which can't pick a random product on its own.
       Falls through to render-in-place if no product is found.        */
    if (param('pick') === '1') {
      var chosen = pickFrom(primaryKey);
      if (chosen && chosen.url) {
        showPicking();
        var sep  = chosen.url.indexOf('?') === -1 ? '?' : '&';
        var dest = chosen.url + sep + 'fr=1'
          + '&trait='     + encodeURIComponent(traitHandle)
          + '&secondary=' + encodeURIComponent(secondaryRaw)
          + '&name='      + encodeURIComponent(param('name'));
        window.location.replace(dest);
        return;
      }
    }

    /* ── Meta Lead event ──────────────────────────────────────────
       Fired here, on the product page the quiz-taker lands on and stays,
       so the pixel beacon can't be cancelled by a redirect (the old bug:
       firing it in the quiz right before navigating away lost ~6 of every 7).
       Only genuine quiz completions carry lead=1; recovery-email links do
       not, so existing leads never double-fire.                         */
    if (param('lead') === '1' && typeof fbq === 'function') {
      try { fbq('track', 'Lead'); } catch (e) {}
    }

    var name         = decodeURIComponent(param('name')) || 'there';
    var secondaryKey = secondaryRaw === 'none' ? 'none' : normalise(secondaryRaw);

    render(primaryKey, secondaryKey, name);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
